import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Mixpanel from 'helpers/Mixpanel.js';
import { getCompetitors, getSubscriptions } from 'components/Pages/Settings/actions.js';
import AddCompetitorsModal from 'components/Modals/AddCompetitorsModal/AddCompetitorsModal.jsx';
import AddSubscriptionsModal from 'components/Modals/AddSubscriptionsModal/AddSubscriptionsModal.jsx';
import { SparkleIcon, TileText, GoButton, TileContainer, TileTitle, AddEntitiesContainer, AddCompetitorsSmall,
  AddCompetitorsLarge, AddSubscriptionsSmall, AddSubscriptionsLarge, PersonalizeText } from './styled.js';

class AddEntitiesSection extends React.Component {
  constructor() {
    super();
    this.state = {
      competitorsModalOpen: false,
      subscriptionsModalOpen: false,
    };
  }

  componentDidMount() {
    this.props.getCompetitors();
    this.props.getSubscriptions();
  }

  render() {
    const { competitorsList, subscriptionsList, userEntity } = this.props;
    const { competitorsModalOpen, subscriptionsModalOpen } = this.state;
    const fetched = competitorsList.fetched && subscriptionsList.fetched;
    const closeCompetitorsModal = () => this.setState({ competitorsModalOpen: false });
    const openCompetitorsModal = () => {
      Mixpanel.track('clicked Competitor Setup Wizard');
      return this.setState({ competitorsModalOpen: true });
    };
    const closeSubscriptionsModal = () => this.setState({ subscriptionsModalOpen: false });
    const openSubscriptionsModal = () => {
      Mixpanel.track('clicked Subscriptions Setup Wizard');
      return this.setState({ subscriptionsModalOpen: true });
    };

    let needsCompetitors = false;
    let needsSubscriptions = false;

    if (fetched) {
      needsCompetitors = competitorsList.data.length === 0;
      needsSubscriptions = subscriptionsList.data.length === 0;
    }

    const needsBoth = needsCompetitors && needsSubscriptions;
    let content = null;

    if (needsBoth && userEntity) {
      content = (
        <React.Fragment>
          <TileContainer half>
            <TileTitle>Add your Competitors</TileTitle>
            <TileText>
              We’ll automatically create a custom Competitor library &
              personalise your home page to feature all of their latest content too.
            </TileText>
            <GoButton onClick={openCompetitorsModal} />
            <AddCompetitorsSmall />
          </TileContainer>
          <TileContainer half>
            <TileTitle>Subscribe to brands & publishers</TileTitle>
            <TileText>
              We’ll automatically create a custom Subscribed library & personalise your home page to
              feature all of their latest content too.
            </TileText>
            <GoButton onClick={openSubscriptionsModal} />
            <AddSubscriptionsSmall />
          </TileContainer>
        </React.Fragment>
      );
    } else if (needsCompetitors && userEntity) {
      content = (
        <TileContainer>
          <TileTitle>Add your competitors</TileTitle>
          <TileText>
            We’ll automatically create a custom Competitor library &
            personalise your home page to feature all of their latest content too.
          </TileText>
          <GoButton onClick={openCompetitorsModal} />
          <AddCompetitorsLarge />
        </TileContainer>
      );
    } else if (needsSubscriptions) {
      content = (
        <TileContainer>
          <TileTitle>Subscribe to brands & publishers</TileTitle>
          <TileText>
            We’ll automatically create a custom Subscribed library & personalise your home page to
            feature all of their latest content too.
          </TileText>
          <GoButton onClick={openSubscriptionsModal} />
          <AddSubscriptionsLarge />
        </TileContainer>
      );
    }

    return (
      <AddEntitiesContainer open={content !== null}>
        <PersonalizeText><SparkleIcon /> PERSONALIZE YOUR BLUEPRINT</PersonalizeText>
        {content}
        <AddCompetitorsModal
          isOpen={competitorsModalOpen}
          close={closeCompetitorsModal}
          submitCallback={() => this.props.history.push('/blueprint/library/competitors')}
        />
        <AddSubscriptionsModal
          isOpen={subscriptionsModalOpen}
          close={closeSubscriptionsModal}
          submitCallback={() => this.props.history.push('/blueprint/library/subscribed')}
        />
      </AddEntitiesContainer>
    );
  }
}


const mapStateToProps = ({
  Settings: { competitorsList, subscriptionsList },
  Account: { userEntity },
}) => ({
  competitorsList, subscriptionsList, userEntity,
});

const mapDispatchToProps = dispatch => ({
  getCompetitors: (clear) => dispatch(getCompetitors(clear)),
  getSubscriptions: (clear) => dispatch(getSubscriptions(clear)),
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddEntitiesSection));
